import { adminApiGet, adminApiPost } from '../client';
import {
  HqActivityResponseSchema,
  HqAiResponseSchema,
  HqTeamResponseSchema,
  type HqActivityReport,
  type HqTeamMember,
} from '../schemas';

/** Dale HQ's own reads and Dale AI (services/api: admin-hq-routes.ts). */

export async function getHqTeam(): Promise<HqTeamMember[]> {
  return (await adminApiGet('/v1/admin/hq/equipo', HqTeamResponseSchema)).data;
}

/** Per business: reservas, cobros, clientes and agents of a `YYYY-MM`. */
export async function getHqActivity(month: string): Promise<HqActivityReport> {
  return (await adminApiGet(`/v1/admin/hq/actividad?mes=${encodeURIComponent(month)}`, HqActivityResponseSchema)).data;
}

export type HqAiTurn = { role: 'user' | 'assistant'; text: string };

/** One question to Dale AI, with the conversation so far; answers the text to show. */
export async function askHqAi(input: { question: string; history: readonly HqAiTurn[] }): Promise<string> {
  const body = input.history.length > 0 ? { question: input.question, history: input.history } : { question: input.question };
  return (await adminApiPost('/v1/admin/hq/ai', HqAiResponseSchema, body)).data.answer;
}
